import type {SimpleFond} from 'src/typings';
import type {FondedAttribute, GridLayout, RelatedRecordsDescriptor, SubRowCreateParam} from 'src/features/record/field-types/types';
import {isNotEmpty} from 'shared/utils/array-utils';

export function supportsRecordRelations(layout: GridLayout): boolean {
    return isNotEmpty(getAllAttributeValues(layout.fondedRowSettings.relatedRecordsDescriptors).flat());
}

export function resolveRelatedRecordsDescriptors(gridLayout: GridLayout, fond: SimpleFond) {
    return resolveGridFieldAttributeValue(gridLayout.fondedRowSettings.relatedRecordsDescriptors, fond.id);
}

export function aggregateSubRowCreateParams(relatedRecordsDescriptors: RelatedRecordsDescriptor[]): SubRowCreateParam[] {
    return relatedRecordsDescriptors.flatMap(({createParams}) =>
        createParams.possibleReferenceTargetFonds.map((possibleReferenceTargetFond) => ({
            referenceTargetFond: possibleReferenceTargetFond,
            fieldTypeId: createParams.fieldTypeId})
        )
    );
}

export function resolveGridFieldAttributeValue<T>(attribute: FondedAttribute<T>, fondId: number): T {
    return attribute.fondedValues[fondId] ?? attribute.defaultValue;
}

export function getAllAttributeValues<T>(attribute: FondedAttribute<T>): T[] {
    return [attribute.defaultValue, ...Object.values(attribute.fondedValues)];
}